var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1556 5.03032L7.1556 13.0303C7.08592 13.1002 7.00313 13.1557 6.91196 13.1936C6.8208 13.2314 6.72306 13.2509 6.62435 13.2509C6.52564 13.2509 6.4279 13.2314 6.33673 13.1936C6.24557 13.1557 6.16278 13.1002 6.0931 13.0303L2.5931 9.53032C2.52333 9.46056 2.46799 9.37774 2.43024 9.28658C2.39248 9.19543 2.37305 9.09774 2.37305 8.99907C2.37305 8.90041 2.39248 8.80272 2.43024 8.71156C2.46799 8.62041 2.52333 8.53759 2.5931 8.46782C2.66286 8.39806 2.74569 8.34272 2.83684 8.30496C2.92799 8.26721 3.02569 8.24777 3.12435 8.24777C3.22301 8.24777 3.32071 8.26721 3.41186 8.30496C3.50301 8.34272 3.58583 8.39806 3.6556 8.46782L6.62497 11.4372L14.0943 3.96907C14.2352 3.82818 14.4263 3.74902 14.6256 3.74902C14.8249 3.74902 15.016 3.82818 15.1568 3.96907C15.2977 4.10997 15.3769 4.30107 15.3769 4.50032C15.3769 4.69958 15.2977 4.89068 15.1568 5.03157L15.1556 5.03032Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Check.dfbe9ac8.svg";
export { ForwardRef as ReactComponent };